import { render, staticRenderFns } from "./FieldsTable.vue?vue&type=template&id=6c772b82&"
import script from "./FieldsTable.vue?vue&type=script&lang=js&"
export * from "./FieldsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports